module.exports = __webpack_public_path__ + "img/inspiration_06@2x.03a4121.jpg";